import Modal from 'src/components/modal/modal';
import styled from 'styled-components';
import { media } from 'src/components/base';

export const StorePopupModal = styled(Modal)`
  ${media.smallOnly`
    width: 90% !important;
  `}

  ${media.mediumOnly`
    width: 90% !important;
  `}

  ${media.largeUp`
    width: 60% !important;
  `}
`;

export const StyledOutlineButton = styled.div`
  margin: auto;
`;
